/** Converte Timestamp do Firestore, Date, string ou número em Date. */
export function toJsDate(value) {
  if (value == null) return undefined;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    return new Date(value.seconds * 1000);
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

/** Retorna timestamp em ms para ordenação (createdAt → updatedAt → 0). */
export function getPropertySortTime(property) {
  const created = toJsDate(property?.createdAt);
  if (created) return created.getTime();
  const updated = toJsDate(property?.updatedAt);
  if (updated) return updated.getTime();
  return 0;
}

export function mapPropertyDoc(doc) {
  const data = doc.data();
  const createdAt = toJsDate(data.createdAt) || toJsDate(data.updatedAt);
  return {
    id: doc.id,
    ...data,
    createdAt,
    updatedAt: toJsDate(data.updatedAt),
  };
}
